module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/CULTURAL STUDIES-5ed3ad5a440b52405919cc64e1715876.png";